export function esSabado() {
  const d = new Date()
  const diaActual = d.getDay()
  if (diaActual === 6) {
    return true
  } else {
    return false
  }
}
